import { render } from "./admin-dashboard.vue?vue&type=template&id=32ffe89e"
import script from "./admin-dashboard.vue?vue&type=script&lang=js"
export * from "./admin-dashboard.vue?vue&type=script&lang=js"

import "./admin-dashboard.vue?vue&type=style&index=0&id=32ffe89e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__